import rest from "@/rest-client";

export const storageRecommendation = {
  state: {
    recommendation: null,
  },
  getters: {
    recommendation: (state) => state.recommendation,
  },
  mutations: {
    recommendation: (state, value) => (state.recommendation = value),
  },
  actions: {
    async recommendStoragePeriod({ commit, rootGetters }) {
      commit("isLoading", true);
      try {
        const criteria = rootGetters["inventoryFilter/criteria"];
        const process = criteria.process;
        const datasource = criteria.datasource;
        if (process || datasource) {
          const response = await rest.post(`/recommendation/paginate/process-datasource-storage-period`, {
            datasourceId: datasource?._id,
            processId: process?._id,
          });
          commit("recommendation", response.data);

          return response;
        }
      } finally {
        commit("isLoading", false);
      }
    },
  },
};
